// Navigation toggle
jQuery(function ($) {
    // Bridge refreshes its custom dropdown on additions only. WooCommerce's
    // default fragment selector does not match this dropdown on removals.
    $(document.body).on('removed_from_cart', function (event, fragments) {
        const content = fragments && fragments['div.widget_shopping_cart_content'];
        if (!content) return;

        const $content = $(content);
        const $items = $content.find('.cart_list, .woocommerce-mini-cart__empty-message');
        const $total = $content.find('.total').contents().not('strong');

        $('.shopping_cart_header').each(function () {
            $(this).find('.shopping_cart_dropdown_inner').empty().append($items.clone());
            $(this).find('.shopping_cart_dropdown > .total').toggle($total.length > 0)
                .children('span').empty().append($total.clone());
        });
    });

    // Restore the subtotal after adding to a cart that was emptied above.
    $(document.body).on('added_to_cart', function () {
        $('.shopping_cart_dropdown > .total').show();
    });
});

window.addEventListener("load", function () {
    watchQuantity();
});

function watchQuantity(){
    let quantities = document.querySelectorAll('.quantity input[type=text]');

    quantities.forEach(quantity => {

        let minus = quantity.previousElementSibling;
        let plus = quantity.nextElementSibling;
        let add_to_cart = quantity.parentElement.nextElementSibling.querySelector('a');

        minus.addEventListener('click', function(e){
            let currentQtyStr = add_to_cart.getAttribute("data-quantity");
            let currentQty = parseInt(currentQtyStr);
            if (currentQty == 0) return;
            let newQty = currentQty-1;
            add_to_cart.setAttribute("data-quantity", newQty);
        });

        plus.addEventListener("click", function (e) {
            let currentQtyStr = add_to_cart.getAttribute("data-quantity");
            let currentQty = parseInt(currentQtyStr);
            let newQty = currentQty+1;
            add_to_cart.setAttribute("data-quantity", newQty);
        });
        
    });
}
